import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import React, {
  PureComponent,
} from 'react';
import {
  SketchPicker,
} from 'react-color';
import classes from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import {
  IColorPickerField,
} from '../formFields';

interface IProps extends IColorPickerField {
  errors: any;
  touched: any;

  onChange(name: string, color: any): any;
}

class ColorPickerField extends PureComponent<IProps> {
  public render() {
    const {
      label, value, errors, onChange, name, touched,
    } = this.props;
    return (
      <FormControl className={classes.filed}>
        <label>{label}</label>
        <SketchPicker
          color={value}
          onChangeComplete={(color: any) => onChange(name, color.hex)}
        />
        {
         errors[name] && touched[name] ? <FormHelperText className={classes.error}>{errors[name]}</FormHelperText> : null
        }
      </FormControl>
    );
  }
}

export default ColorPickerField;
